<template>
  <mdb-container fluid>
    <mdb-row>
      <mdb-col>
        <button @click="reset()" class="dt-btn-primary" size="sm">
          Reset <i class="fas fa-sync"></i>
        </button>
      </mdb-col>
    </mdb-row>
  </mdb-container>
</template>

<script>
import { resetMap } from "../common/utilities/mapController.js";
export default {
  name: "Reset",
  methods: {
    reset() {
      this.$store.commit("resetMapFilters");
      resetMap();
      this.$emit("reset");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
